export class BadRequestError extends Error {
  constructor (error) {
    super(error.response.body)
    this.stack = error.stack
    this.name = 'BadRequestError'
  }
}